export const TrustInfoContent = {
  trustToTrust: {
    currentTrustNameLabel: 'Current legal trust name',
    currentTrustDateLabel: 'Current trust date',
    newTrustNameLabel: 'New legal trust name',
    newTrustDateLabel: 'New trust date',
    trustNameCheckboxLabel: `I need to update the trust's name`,
    trustDateCheckboxLabel: `I need to update the trust's date`,
    trustNameCheckboxTooltip: `There may have been instructions to update the trust's name upon passing. If so, the new name should be reflected in the uploaded trust documents.`,
    trustDateCheckboxTooltip: `There may have been instructions to update the trust's date upon the decedents passing. If so, the new date should be reflected in the uploaded trust documents.`,
  },
  pageTitle: 'Next, provide some information about the trust',
  trustNameLabel: 'Full legal trust name',
  trustDateLabel: 'Trust date',
  trustDateTooltip:
    'This is the date the trust was created. It can be found in the trust documents.',
  numberQuestion: 'Does the trust report under an EIN or Social Security number?',
  numberQuestionTooltip: `If the trust\'s income is reported on the living grantor\'s tax return, use their Social Security number. If the trust files separately, use an EIN.
    <a href="https://www.irs.gov/" target="_blank" class="c11n-link c11n-link--reinforced c11n-link--normal c11n-link--secondary c11n-link--on-dark">
      <span class="c11n-link__content">Apply online</span>
    </a>
    if you don\'t have an EIN.`,
  numberQuestionOptions: ['EIN', 'Social Security number'],
  countryQuestion: 'Country where the trust was established',
  countryOptions: ['U.S.', 'Other'],
  taxResidencyQuestion: 'Tax residency',
  grantorQuestion: 'Is the grantor a U.S. citizen?',
  trustAddress: 'Trust address',
  trustAddressCheckbox: 'Same as trustee address',
  trustAddressDescription:
    "This can't be a P.O. box, private mailbox service, or rural route, but can be an APO (army post office) or FPO (fleet post office).",
  addressLabel: 'Address',
  addressFieldDescription: 'Include apartment, suite, or unit number',
  zipCodeLabel: 'Zip code',
  cityLabel: 'City',
  stateLabel: 'State',
  mailingAddress: 'Mailing address',
  mailingAddressCheckbox: 'Same as trust address',
  citizenshipQuestion: 'Is the grantor a U.S. citizen?',
  requiredError: 'This field is required',
  continueButton: 'Continue',
};
